import { render, staticRenderFns } from "./addCategoryccc.vue?vue&type=template&id=082a3c5c&scoped=true&"
import script from "./addCategoryccc.vue?vue&type=script&lang=js&"
export * from "./addCategoryccc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a3c5c",
  null
  
)

export default component.exports